<span class="_content">
    <ng-content></ng-content>
</span>
@if (icon) {
<i class="_icon"
   [lineHeightBy]="'_content'"
   [ngClass]="'icon-' + icon"></i>
}
@if (isBusy) {
<div class="_loader">
    <loader-1 class="block"></loader-1>
</div>
}